import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PublicStationsView } from './components/PublicStationsView';
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
      <Routes data-id="element-6">
        <Route path="/" element={<PublicStationsView data-id="element-8" />} data-id="element-7" />
        <Route path="/admin" element={<App data-id="element-10" />} data-id="element-9" />
      </Routes>
    </BrowserRouter>;
}